import classNames from 'classnames';
import * as React from 'react';
import { useIntl } from 'react-intl';
import StarRating from '../../../../../../atoms/icons/StarRating';
import MerchantTag from '../../../../../../molecules/merchant/common/tags/MerchantTag';
import LowestPrice from '../../../../../../molecules/merchant/common/texts/LowestPrice';
import { BookingPageTagName } from '../../../../../../domain/entities/BookingPage';
import MerchantCourseDetailsReservationButton from '../../../../../../molecules/merchant/resources/book/MerchantCourseDetailsReservationButton';

import css from './MerchantCourseDetailsHeader.module.scss';
import { MerchantSetting } from '../../../../../../interfaces/merchants';

export interface OwnProps {
  merchantSetting: MerchantSetting;
  isBookable: boolean;
  isEvent: boolean;
  isFullyBooked: boolean;
  name: string;
  nickname: string;
  public_id: string;
  tag_names: BookingPageTagName[];
  rate_count: number;
  rate?: number;
  lowest_price?: number;
}

type Props = OwnProps;

const MerchantCourseDetailsHeader: React.FC<Props> = (props) => {
  const {
    merchantSetting,
    isEvent,
    isFullyBooked,
    name,
    tag_names,
    rate_count,
    rate,
    lowest_price,
  } = props;
  const classes = classNames(css.MerchantCourseDetailsHeader);
  const intl = useIntl();

  return (
    <div className={classes}>
      <div className={css.MerchantCourseDetailsHeader__Inner}>
        {tag_names.map((tag, i) => (
          <MerchantTag key={i} status={tag} />
        ))}
        <div className={css.MerchantCourseDetailsHeader__Header}>
          <h1 className={css.MerchantCourseDetailsHeader__Title}>{name}</h1>
          <div className={css.MerchantCourseDetailsHeader__SummaryContainer}>
            <div className={css.MerchantCourseDetailsHeader__Summary}>
              <span>
                {merchantSetting.is_customer_review_active && (
                  <>
                    <StarRating
                      className={css.MerchantCourseDetailsHeader__StarRating}
                      rate={rate || 0}
                    />
                    {rate_count > 0 && (
                      <span
                        className={css.MerchantCourseDetailsHeader__ReviewCount}
                      >
                        {`(${rate_count})`}
                      </span>
                    )}
                  </>
                )}
              </span>
              {isEvent && lowest_price && (
                <LowestPrice
                  className={css.MerchantCourseDetailsHeader__Price}
                  lowestPrice={lowest_price}
                />
              )}
            </div>
            <div className={css.MerchantCourseDetailsHeader__ButtonContainer}>
              <MerchantCourseDetailsReservationButton
                contactUrl={merchantSetting.contact_url}
                {...props}
              />
            </div>
          </div>
        </div>
        {isFullyBooked && (
          <p className={css.MerchantCourseDetailsHeader__Notice}>
            {intl.formatMessage({
              id: 'merchants.bookingPages.notice.fullyBooked',
            })}
          </p>
        )}
      </div>
    </div>
  );
};

export default MerchantCourseDetailsHeader;
